import React from 'react'
import Paper from 'material-ui/Paper'
import { styles } from './Styles'
import LocalShipping from 'material-ui/svg-icons/maps/local-shipping'
import RaisedButton from 'material-ui/RaisedButton'
import { Link } from 'react-router-dom'
import { themeColors } from '../../styles/theme'

const SpedizioneOggetti = () => (
  <Paper style={styles.paper}>
    <h4 style={styles.titles}>
      <LocalShipping style={styles.titleIcon} />
      Spedizione degli oggetti
    </h4>
    <p>
      Le tariffe di spedizione sono consultabili sul sito di Poste Italiane (
      <a href="https://www.poste.it/" target="_blank" rel="noopener noreferrer">
        www.poste.it
      </a>
      )
    </p>
    <p>
      Spedire un oggetto di peso inferiore a 250 grammi, compreso l'imballo, richiede 3,50 euro di spese di spedizione con posta4 (4,35 euro fino a 350 grammi). Per ulteriori dettagli leggere qui:
      {' '}
      <a
        href="http://www.poste.it/postali/italia/posta4.shtml"
        target="_blank"
        rel="noopener noreferrer">
        http://www.poste.it/postali/italia/posta4.shtml
      </a>
      .
      Se invece si sceglie di spedire con raccomandata leggere qui:
      {' '}
      <a
        href="http://www.poste.it/postali/italia/raccomandata.shtml"
        rel="noopener noreferrer"
        target="_blank">
        http://www.poste.it/postali/italia/raccomandata.shtml
      </a>
      .
    </p>
    <p>
      Spedire un libro invece costa solo 1,28 euro. La modalità di spedizione è il
      {' '}
      <span style={{ color: themeColors.positive }}>
        "Pieghi di Libri"
      </span>
      , scopri di più sulla nostra guida.
    </p>
    <RaisedButton
      label="Guida a pieghi di libri"
      primary={true}
      fullWidth={true}
      containerElement={
        <Link to="/pieghi-di-libri#pieghi-di-libri" target="_blank" />
      }
    />
  </Paper>
)

export default SpedizioneOggetti



// WEBPACK FOOTER //
// ./src/common/Infotext/SpedizioneOggetti.js